'use client';

import React from 'react';
import { cx } from '@/app/lib/utils';

interface CircularProgressProps {
  progress: number;
  size?: number;
  strokeWidth?: number;
  backgroundStrokeWidth?: number;
  className?: string;
  textClassName?: string;
  showText?: boolean;
}

const CircularProgress = ({
  progress,
  size = 56,
  strokeWidth = 9,
  backgroundStrokeWidth = 4,
  className,
  textClassName,
  showText = true,
}: CircularProgressProps) => {
  const radius = size / 2;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className={cx('relative flex items-center justify-center', className)}>
      <svg height={size} width={size} className="rotate-[-90deg]">
        <circle
          stroke="#D1D5DC"
          fill="transparent"
          strokeWidth={backgroundStrokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="#155DFC"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          style={{ strokeDashoffset }}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      {showText && (
        <span
          className={cx(
            'absolute text-sm font-bold text-blue-600',
            textClassName,
          )}
        >
          {progress}%
        </span>
      )}
    </div>
  );
};

export default CircularProgress;
